"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _refreshTimer = _interopRequireDefault(require("./refreshTimer"));

/**
 * Created by wqw on 2018/1/10.
 */
var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // 注入全局定时器
  for (var method in _refreshTimer["default"]) {
    if (Object.prototype.hasOwnProperty.call(_refreshTimer["default"], method)) {
      Vue.prototype[method] = _refreshTimer["default"][method];
    }
  }

  Vue.options.beforeDestroy.push(function () {
    this.clearRefreshTimer();
  });
};

var _default = {
  install: install
};
exports["default"] = _default;